import axios from "axios";
import io from "socket.io-client";

export class BaseService {
  constructor(_hostName) {
    this.hostName = _hostName;
    this.socket = io(_hostName);
  }

  makeGetRequest(endPoint) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = this.hostName + endPoint;
        const res = await axios.get(url);
        return resolve(res.data);
      } catch (error) {
        alert(error);
        reject(error);
      }
    });
  }

  emitData(topic, data) {
    //console.log(data);

    this.socket.emit(topic, data);
  }
}
